// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__8R6wN","header":"ReportDetails_header__2ee7j","title":"ReportDetails_title__18qrh","left":"ReportDetails_left__5n5Kv"};